// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementPresetEmailTemplatesIdResult = objectOf({
  id: string,
  name: string,
  description: maybe(string),
  subject: string,
  template: string,
  email_amp_body: maybe(string, true),
  plaintext_body: maybe(string, true),
  dnd_template_json: maybe(string),
  is_dnd_template: boolean,
  preheader: maybe(string, true),
  should_whitespace_preheader: boolean,
  should_inline_css: boolean,
  thumbnail_image_url: string,
  attached_images: arrayOf(
    objectOf({
      app_group_id: maybe(string),
      id: string,
      name: string,
      url: string,
      ext: string,
      created_at: number,
      created_by: maybe(string),
      size: maybe(number),
      known_width: maybe(number),
      known_height: maybe(number),
      progress: maybe(number),
      error: maybe(string),
      warning: maybe(string),
      last_edited_by: maybe(string),
      ratio: arrayOf(maybe(number)),
      territory_ids: arrayOf(maybe(string)),
      type: maybe(string),
    })
  ),
});
